/* eslint-disable eslint-comments/no-restricted-disable */

import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type {
	DataSourceEntryPoints,
	ExtraProps,
	DataSourceTabName,
} from '@jira/assets-app__data-manager-common/src/ObjectListViewTypes.types.tsx';
import { configurationTabEntryPoint } from '@jira/assets-app__data-manager-source/src/configurationTabEntryPoint.entrypoint.tsx';
import { dataTabEntryPoint } from '@jira/assets-app__data-manager-source/src/dataTabEntryPoint.entrypoint.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

const TABS = {
	configuration: configurationTabEntryPoint,
	data: dataTabEntryPoint,
} as const;

const DEFAULT_TAB: DataSourceTabName = 'configuration';

const isValidTab = (tab: unknown): tab is DataSourceTabName =>
	typeof tab === 'string' && Object.keys(TABS).includes(tab);

type AssetsDataManagerDataSourceEntryPointComponent = EntryPointComponent<
	{},
	DataSourceEntryPoints,
	{},
	ExtraProps
>;

export const assetsDataManagerDataSourceEntryPoint: EntryPoint<
	AssetsDataManagerDataSourceEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<AssetsDataManagerDataSourceEntryPointComponent>(
		/* webpackChunkName: "async-assets-data-manager-data-source", jiraSpaEntry: "async-assets-data-manager-data-source" */ './AssetsDataManagerDataSourceSpa.tsx',
	),
	getPreloadProps: ({
		context: {
			match: { params },
		},
	}: EntryPointRouteParams) => {
		const validTab = isValidTab(params?.tab) ? params.tab : DEFAULT_TAB;
		const extraProps = {
			jobId: params?.dataSourceId || '',
		};
		return {
			entryPoints: {
				[validTab]: {
					entryPoint: TABS[validTab],
					entryPointParams: {},
				},
			},
			extraProps,
		};
	},
});
